class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      this.itemsCount.innerHTML = state.products.item_count;
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }
}
customElements.define('cart-link', CartLink);
const POLL_INTERVAL = 2000; // 1秒

// 启动定时器
const pollCart = setInterval(() => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
     // console.log('当前购物车数据:', cart);
      // 更新页面上的购物车信息（示例）
      document.querySelectorAll('items-count').forEach(element => {
       // console.log(element)
         element.textContent = cart.item_count;
      });
    })
    .catch(error => {
      console.error('获取购物车失败:', error);
    });
}, POLL_INTERVAL);
